export default {
  ladder: {
    width: 50,
  },
  lane: {
    width: 100,
  },
  gel: {
    fill: '#eee',
    padding: 20,
    height: 500,
  },
  band: {
    fill: '#666',
    height: 4,
    width: 60,
    active: {
      fill: '#000',
    },
  },
  header: {
    height: 30,
  },
  padding: 20,
  type: {
    height: 15,
  },
};
